import { createSlice } from '@reduxjs/toolkit'

export const bannerSlice = createSlice({
  name: 'banners',
  initialState: {
    banners: [],
    loading: false,
    error: null,
  },
  reducers: {
    setBannersLoading: (state, action) => {
      state.loading = action.payload
    },
    setBanners: (state, action) => {
      state.banners = action.payload
      state.loading = false
      state.error = null
    },
    setBannersError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    clearBanners: (state) => {
      state.banners = []
      state.error = null
    }
  }
})

export const {
  setBannersLoading,
  setBanners,
  setBannersError,
  clearBanners
} = bannerSlice.actions

export default bannerSlice.reducer
